// extracted by mini-css-extract-plugin
export default {"anchorPoint":"style_anchorPoint__cyENO"};